/* istanbul ignore file */
import React from 'react';
import { CreateButton } from 'framework/ui/ui-builder';
import { useEmployeeContractUrl } from 'domain/people/employee/contracts/employeeContractRouting';
import { CREATE_EMPLOYEE_CONTRACT } from 'domain/people/employee/contracts/shared/employeeContractsService';

const CreateEmployeeContractButton = () => {
  const { getCreateUrl } = useEmployeeContractUrl();

  return (
    <CreateButton
      variant="contained"
      label="Add contract"
      size="small"
      url={getCreateUrl()}
      permissionToCheck={CREATE_EMPLOYEE_CONTRACT}
    />
  );
};

export default CreateEmployeeContractButton;
